import { BARGE_KIND_OPTIONS, getFuelGradeOptions } from './bunkerInfoRules'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { Input, Select } from 'antd'
import React, { useEffect, useMemo } from 'react'
import Heading from 'components/Heading'
import { useTranslation } from 'react-i18next'

const BunkerInfoSection = () => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext()
  const kind = useWatch({ control, name: 'bunker.bargeKind' })
  const fuelGrade = useWatch({ control, name: 'bunker.fuelGradePerBdn' })

  const fuelGradeOptions = useMemo(() => getFuelGradeOptions(kind), [kind])

  useEffect(() => {
    if (!fuelGrade) return
    const stillValid = fuelGradeOptions.some(
      option => option.value === fuelGrade
    )

    if (!stillValid) {
      setValue('bunker.fuelGradePerBdn', '')
      setValue('laboratory.isoYear', '')
    }
  }, [fuelGrade, fuelGradeOptions, setValue])

  return (
    <div className="bunker-section__content">
      <Heading level={4}>{t('rob.survey.bunker.bunkerInfo')}</Heading>

      <div className="bunker-field-row">
        <label className="bunker-field-row__label">Barge Kind</label>
        <Controller
          control={control}
          name="bunker.bargeKind"
          render={({ field: { onChange, value } }) => (
            <Select
              className="bunker-field-row__input"
              options={BARGE_KIND_OPTIONS}
              placeholder="Select kind"
              value={value || undefined}
              onChange={nextKind => {
                onChange(nextKind)
                setValue('laboratory.isoYear', '')
              }}
            />
          )}
        />
      </div>

      <div className="bunker-field-row">
        <label className="bunker-field-row__label">Fuel Grade as per BDN</label>
        <Controller
          control={control}
          name="bunker.fuelGradePerBdn"
          render={({ field: { onChange, value } }) => (
            <Select
              className="bunker-field-row__input"
              disabled={!kind}
              options={fuelGradeOptions}
              placeholder="Select fuel grade"
              showSearch
              value={value || undefined}
              onChange={nextFuelGrade => {
                onChange(nextFuelGrade)
                setValue('laboratory.isoYear', '')
              }}
            />
          )}
        />
      </div>

      <div className="bunker-field-row">
        <label className="bunker-field-row__label">
          {t('rob.survey.bunker.bdn.density15')}
        </label>
        <Controller
          control={control}
          name="bunker.bdn.density15"
          render={({ field }) => (
            <Input
              {...field}
              className="bunker-field-row__input"
              placeholder="kg/m³"
            />
          )}
        />
      </div>

      <div className="bunker-field-row">
        <label className="bunker-field-row__label">
          {t('rob.survey.bunker.bdn.volume15')}
        </label>
        <Controller
          control={control}
          name="bunker.bdn.volume15"
          render={({ field }) => (
            <Input
              {...field}
              className="bunker-field-row__input"
              placeholder="m³"
            />
          )}
        />
      </div>

      <div className="bunker-field-row">
        <label className="bunker-field-row__label">
          {t('rob.survey.bunker.barge.volume15')}
        </label>
        <Controller
          control={control}
          name="bunker.barge.volume15"
          render={({ field }) => (
            <Input
              {...field}
              className="bunker-field-row__input"
              placeholder="m³"
            />
          )}
        />
      </div>

      <div className="bunker-field-row">
        <label className="bunker-field-row__label">
          {t('rob.survey.bunker.vsl.volume15')}
        </label>
        <Controller
          control={control}
          name="bunker.volume15CPerVsl"
          render={({ field }) => (
            <Input
              {...field}
              className="bunker-field-row__input"
              placeholder="m³"
            />
          )}
        />
      </div>
    </div>
  )
}

export default BunkerInfoSection
